import { render, staticRenderFns } from "./CalendarSection.vue?vue&type=template&id=72570e42&"
import script from "./CalendarSection.vue?vue&type=script&lang=js&"
export * from "./CalendarSection.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
